export default __webpack_public_path__ + "static/media/9.4d61b10a.webp";